// Modal as a separate component
import React, { PropsWithChildren } from 'react'
import { Icon, Typography } from 'foundations-library/components'
import { makeStyles } from '@material-ui/core'

interface PropsInterface {
        onClickBack?(): any
        'data-testid'?: string
}

const jss = () => {
    return {
        dialogTitle: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '20px'
        },
        dialogTitleBackBtn: {
            marginRight: '10px'
        }
    }
}
const useStyles = makeStyles(jss)

/**
 *
 */
const DialogTitle = ({
    children,
    onClickBack,
    'data-testid': dataTestId = 'dialog-title'
}: PropsWithChildren<PropsInterface>): JSX.Element => {
    const styles = useStyles()

    return <div className={`${styles.dialogTitle} dialog-title`}>
        {
            onClickBack &&
            <Icon
                name='back-small'
                color='neutral-900'
                size={24}
                onClick={onClickBack}
                className={styles.dialogTitleBackBtn}
                data-testid={`${dataTestId}-back-button`}
            />
        }
        <Typography variant='h6' data-testid={dataTestId}>{children}</Typography>
    </div>
}

export default DialogTitle
